import { FunctionComponent, PropsWithChildren, ReactNode, RefObject } from 'react';

interface TabEmptyItemProps extends PropsWithChildren {
  group?: string;
  title: string | ReactNode;
  className?: string;
  forwardedRef?: RefObject<HTMLLIElement>;
  onClick?: (eventKey: string) => void;
  eventKey: string;
  navigation?: boolean;
  icon?: ReactNode;
  onlyRenderOnActive?: boolean;
  classBuilder?: () => string;
}

const TabEmptyItem: FunctionComponent<TabEmptyItemProps> = ({
  title,
  className,
  forwardedRef,
  onClick,
  eventKey,
  navigation,
  icon,
  classBuilder = (arg: string) => arg,
}) => {
  const c = classBuilder;
  return (
    <li
      className={className}
      role="presentation"
      key={`tablist-${eventKey}`}
      ref={forwardedRef}
    >
      <button
        type="button"
        className={c('__tabs_item__button')}
        onClick={() => onClick(eventKey)}
        role="tab"
        tabIndex={navigation ? -1 : 0}
      >
        <div className={c('__tabs_item--label')}>
          {icon && <div className={c('__tabs_item--icon')}>{icon}</div>}
          {typeof title === 'string' ? (
            <div className={c('__tabs_item--title')}>{title}</div>
          ) : title}
        </div>
      </button>
    </li>
  );
};

export default TabEmptyItem;
